import SilenceModal from "./SilenceModal";
import TooLoudModal from "./TooLoudModal";
import TooSoftModal from "./TooSoftModal";
import TooNoisyModal from "./TooNoisyModal";
import DisableSpeechForNowModal from "./DisableSpeechForNowModal";
import SubmitSreReportModal from "./SubmitSreReport";
import reducer, {
// redux
selectors, actions, initialState,
// action contants
SRE_SHOW_SILENCE_MODAL, SRE_HIDE_SILENCE_MODAL, SRE_SHOW_TOO_LOUD_MODAL, SRE_HIDE_TOO_LOUD_MODAL, SRE_SHOW_TOO_SOFT_MODAL, SRE_HIDE_TOO_SOFT_MODAL, SRE_SHOW_TOO_NOISY_MODAL, SRE_HIDE_TOO_NOISY_MODAL, SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL, SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL, SRE_SHOW_SUBMIT_REPORT_MODAL, SRE_HIDE_SUBMIT_REPORT_MODAL, SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED, SRE_RESET_NUMBER_REPORTS_SUBMITTED, SRE_DISABLE_SPEECH_FOR_NOW_MODAL_DISABLE_SPEECH_AFTER_ACTION, SRE_AUDIO_QUALITY_MODAL_DISABLE_SPEECH_AFTER_ACTION } from "./audio-quality-modals-reducer";

var SreAudioQualityModals = {
  // redux
  reducer: reducer,
  selectors: selectors,
  actions: actions,
  initialState: initialState,
  // action contants
  SRE_SHOW_SILENCE_MODAL: SRE_SHOW_SILENCE_MODAL,
  SRE_HIDE_SILENCE_MODAL: SRE_HIDE_SILENCE_MODAL,
  SRE_SHOW_TOO_LOUD_MODAL: SRE_SHOW_TOO_LOUD_MODAL,
  SRE_HIDE_TOO_LOUD_MODAL: SRE_HIDE_TOO_LOUD_MODAL,
  SRE_SHOW_TOO_SOFT_MODAL: SRE_SHOW_TOO_SOFT_MODAL,
  SRE_HIDE_TOO_SOFT_MODAL: SRE_HIDE_TOO_SOFT_MODAL,
  SRE_SHOW_TOO_NOISY_MODAL: SRE_SHOW_TOO_NOISY_MODAL,
  SRE_HIDE_TOO_NOISY_MODAL: SRE_HIDE_TOO_NOISY_MODAL,
  SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL: SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL,
  SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL: SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL,
  SRE_SHOW_SUBMIT_REPORT_MODAL: SRE_SHOW_SUBMIT_REPORT_MODAL,
  SRE_HIDE_SUBMIT_REPORT_MODAL: SRE_HIDE_SUBMIT_REPORT_MODAL,
  SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED: SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED,
  SRE_RESET_NUMBER_REPORTS_SUBMITTED: SRE_RESET_NUMBER_REPORTS_SUBMITTED,
  // optional callback actions - so clients can do more things after disabling speech
  SRE_DISABLE_SPEECH_FOR_NOW_MODAL_DISABLE_SPEECH_AFTER_ACTION: SRE_DISABLE_SPEECH_FOR_NOW_MODAL_DISABLE_SPEECH_AFTER_ACTION,
  SRE_AUDIO_QUALITY_MODAL_DISABLE_SPEECH_AFTER_ACTION: SRE_AUDIO_QUALITY_MODAL_DISABLE_SPEECH_AFTER_ACTION,
  // components
  SilenceModal: SilenceModal,
  TooLoudModal: TooLoudModal,
  TooSoftModal: TooSoftModal,
  TooNoisyModal: TooNoisyModal,
  DisableSpeechForNowModal: DisableSpeechForNowModal,
  SubmitSreReportModal: SubmitSreReportModal
};

export default SreAudioQualityModals;